const mEditionBillingProductCreate = {
  mEditionBillingProductCreate: {
    alerts: {
      updateSubscription: {
        error: 'Un error ha ocurrido. Verifica que la sucripción este activa.',
        success: 'Se canceló en forma exitosamente la suscripción.',
        successGateway: 'Solicitud de cancelación exitosa. Deberás esperar la confirmación de la pasarela de pago.'
      },

      updateVentasConfirmarPago: {
        error: 'Un error ha ocurrido. Verifica los datos del pago y vuelve a intentarlo.',
        success: 'Se confirmó el pago de forma exitosamente.'
      },

      updateVentasReembolsarPago: {
        error: 'Un error ha ocurrido. Verifica los datos del pago y vuelve a intentarlo.',
        success: 'Se reembolso el pago de forma exitosamente.',
        successGateway: 'Solicitud de reembolso exitosa. Deberás esperar la confirmación de la pasarela de pago.'
      }
    },

    info: {
      product: {
        academy: 'Universidad',

        admins: 'Administradores',

        affiliations: 'Afiliaciones',

        assets: 'Proyectos',

        commissions: {
          line1: 'Comisiones',
          line2: 'Sin Comisiones'
        },

        evaluations: 'Evaluaciones',

        instructors: 'Instructores',

        integrations: 'Integraciones',

        liveClasses: 'Clases en vivo por Zoom',

        mails: 'Listas de e-mail',

        maps: 'Mapas de Aprendizaje',

        not: 'No',

        products: 'Productos',

        projects: 'Proyectos',

        salesData: 'Puntos de Venta',

        students: 'Alumnos',

        studentControl: 'Control de alumnos',

        studentImport: 'Importación de alumnos',

        teachers: 'Profesores',

        unlimited: 'Ilimitado'
      }
    },

    tooltips: {
      actions: 'Acciones',
      confirm: 'Confirmar',
      invoice: 'Ver',
      refund: 'Reembolsar'
    }
  }
}

export default mEditionBillingProductCreate
